import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-home-line',
  imports: [],
  templateUrl: './home-line.html',
  styleUrl: './home-line.scss',
})
export class HomeLine {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
